import { useEffect, useState } from "react";
import { useAdminDispatch, useAdminSelector } from "../../../stores/AdminStore";
import { NavLink, useLocation } from "react-router-dom";
import { NavigationItem } from "../../../models/NavigationItem";
import classNames from "classnames";
import { Button } from "../../ui/components/Button";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { setSideMenu } from "../../../stores/MenuSlice";
import { useMediaBreakpoint } from "@unleashed/hooks/useMediaBreakpoint";

export interface SideMenuProps {
  menu: NavigationItem[];
}

export const SideMenu = ({ menu }: SideMenuProps) => {
  const location = useLocation();
  const dispatch = useAdminDispatch();
  const { selectedProduct } = useAdminSelector((s) => s.pos);
  const breakpoint = useMediaBreakpoint();
  const [initialBreakpoint] = useState(breakpoint);
  const open = useAdminSelector((s) => s.menu.open);
  const [activeItem, setActiveItem] = useState<NavigationItem | undefined>(
    undefined
  );

  const handleToggle = () => {
    dispatch(setSideMenu(!open));
  };

  useEffect(() => {
    const path = location.pathname.split("/");
    setActiveItem(menu.find((m) => path.some((p) => p === m.path)));
  }, [dispatch, location, menu]);

  useEffect(() => {
    if (initialBreakpoint == "sm" || initialBreakpoint == "md") {
      dispatch(setSideMenu(false));
    }
  }, [dispatch, initialBreakpoint]);

  return (
    <div
      className={classNames(
        "flex z-40",
        open
          ? "flex-col fixed w-full md:w-80 top-0 bottom-0 bg-gray-300"
          : "h-16 md:h-14 fixed top-0 left-0 bg-black"
      )}
    >
      <Button
        title={t`Menu`}
        variant="none"
        onClick={() => {
          if (!selectedProduct) handleToggle();
        }}
        className={classNames(
          "w-8 h-8 md:w-14 md:h-14 text-2xl md:text-4xl flex",
          "justify-center items-center select-none",
          open ? "text-black" : "text-white"
        )}
      >
        {open ? (
          <FontAwesomeIcon icon={faBars} />
        ) : (
          <FontAwesomeIcon
            icon={faBars}
            className={`${
              selectedProduct !== undefined
                ? "text-gray-400 cursor-not-allowed"
                : ""
            }`}
          />
        )}
      </Button>
      {open && (
        <img
          src={"/admin-logo.svg"}
          className="-mt-8 md:-mt-14 h-40 pointer-events-none user-select-none"
          alt="command-center"
        />
      )}
      {open &&
        menu.map((m, i) => (
          <NavLink
            key={i}
            to={m.path}
            className={classNames(
              "px-2 md:px-4 py-2 md:py-4 font-semibold w-full",
              m === activeItem ? "font-bold bg-unleashed-pink text-white" : ""
            )}
          >
            {m.title}
          </NavLink>
        ))}
      {/*FIXME To be implemented later*/}
      {/*{*/}
      {/*  !!locationSlug &&*/}
      {/*  <div className="mt-auto sticky">*/}
      {/*    <div className="border-t border-gray-400 px-2 py-2 md:px-4*/}
      {/*      md:py-4">*/}
      {/*      <LocationInfo/>*/}
      {/*    </div>*/}
      {/*    <div className="border-t border-gray-400 px-2 py-2 md:px-4*/}
      {/*      md:py-4">*/}
      {/*      <LocationTime/>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*}*/}
    </div>
  );
};
